import React from 'react'
import {
  Button,
  Div,
  Flex,
  Icon,
  Text,
  VStack,
} from '@sendoutcards/quantum-design-ui'
import { ValidateEmailVerificationCodeFailureType } from 'src/graphql'

export type ValidationError = {
  type: ValidateEmailVerificationCodeFailureType
  message: string
}

export type ValidationFailureEmailVerificationProps = {
  onRequestAgain: () => void
  onRetry: () => void
  validationFailure: ValidationError
}

export const ValidationFailureEmailVerification: React.FC<ValidationFailureEmailVerificationProps> = props => {
  const { onRequestAgain, onRetry, validationFailure } = props

  return (
    <Flex justifyContent="center" flexDirection="column" alignItems="center">
      <Div
        width="84px"
        height="84px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderWidth="default"
        borderColor={{ swatch: 'danger', shade: 'base' }}
        borderStyle="solid"
        borderRadius="circle"
      >
        <Icon name="exclamation" primaryColor="danger" size="xLarge" />
      </Div>
      <Text
        type="largeBody"
        alignment="center"
        content={validationFailure.message}
        outset={{ vertical: 'x3' }}
      />
      <VStack gap="x3" justifyContent="center" alignItems="center">
        {validationFailure.type !==
          ValidateEmailVerificationCodeFailureType.TOO_MANY_ATTEMPTS && (
          <Button
            outlined={true}
            type="shadow"
            fullWidth={true}
            title={
              validationFailure.type ===
              ValidateEmailVerificationCodeFailureType.INCORRECT_CODE
                ? 'Try Code Again'
                : 'Resend Code'
            }
            onClick={() =>
              validationFailure.type ===
              ValidateEmailVerificationCodeFailureType.INCORRECT_CODE
                ? onRetry()
                : onRequestAgain()
            }
          />
        )}
      </VStack>
    </Flex>
  )
}
